var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('i',{staticClass:"circle-arrow"})]),_vm._v(" "),_c('li',[_vm._v("Peter Parker (SPIDERMAN) "),_c('span',[_vm._v("23/06/16 15h08")])]),_vm._v(" "),_c('li',[_vm._v("Bonjour, je voudrais savoir si mon avenant à bien été pris en compte dans mon contrat")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b99bd9ec","hasScoped":true,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Dashboard/Messenger/MessengerItem.vue
// module id = 1991
// module chunks = 0